
const homeRoute = [
];

const state = {
  tabRouterList: homeRoute,
  isRefreshing: false,
};

const mutations = {
  // 处理刷新
  toggleTabRouterAlive(state, routeIdx) {
    state.isRefreshing = !state.isRefreshing;
    state.tabRouterList[routeIdx].isAlive = !state.tabRouterList[routeIdx].isAlive;
  },
  // 处理新增
  appendTabRouterList(state, newRoute) {
    if (!state.tabRouterList.find((route) => route.path === newRoute.path))
      // eslint-disable-next-line no-param-reassign
      state.tabRouterList = state.tabRouterList.concat({ ...newRoute, isAlive: true });
  },
  // 处理关闭当前
  subtractCurrentTabRouter(state, newRoute) {
    const { routeIdx } = newRoute;
    state.tabRouterList = state.tabRouterList.slice(0, routeIdx).concat(state.tabRouterList.slice(routeIdx + 1));
  },
  // 处理关闭右侧
  subtractTabRouterBehind(state, newRoute) {
    const { routeIdx } = newRoute;
    state.tabRouterList = state.tabRouterList.slice(0, routeIdx + 1);
  },
  // 处理关闭左侧
  subtractTabRouterAhead(state, newRoute) {
    const { routeIdx } = newRoute;
    state.tabRouterList = homeRoute.concat(state.tabRouterList.slice(routeIdx));
  },
  // 处理关闭其他
  subtractTabRouterOther(state, newRoute) {
    const { routeIdx } = newRoute;
    state.tabRouterList = homeRoute.concat([state.tabRouterList[routeIdx]]);
  },
  removeTabRouterList() {
    state.tabRouterList = [];
  },
  initTabRouterList(state, newRoute) {
    state.tabRouterList = newRoute;
  },
};

const getters = {
  tabRouterList: (state) => state.tabRouterList,
  isRefreshing: (state) => state.isRefreshing,
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/tab-router.js